module.exports = __webpack_public_path__ + "img/optimove.7a3a1ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/optimove.png
// module id = P0G5
// module chunks = 39 44